import { atom } from 'recoil'

export const loginModal = atom<boolean>({
    key: 'customerLoginModal',
    default: false,
})
